// extracted by mini-css-extract-plugin
module.exports = {"root":"Skeleton_root__-uw6H"};